import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrepareSelfComponent } from './prepare-self.component';
import { FormsModule }   from '@angular/forms';
import {PdfViewerModule} from "ng2-pdf-viewer";
import { SharedModule } from '../shared/shared.module';
import { PdfFormDesignerModule } from '../../../../libs/form-designer/projects/pdf-form-designer/src/public-api';

@NgModule({
    imports: [CommonModule, FormsModule, PdfViewerModule, SharedModule, PdfFormDesignerModule, PrepareSelfComponent],
    exports: [PrepareSelfComponent]
})

export class PrepareSelfModule { }
